import React from "react";
import { useTranslation } from "react-i18next";
import "./AboutUsSection1.css";
import Agha from "../../../assets/hussen_agha-min-min.png";
import AboutUsDivider from "../AboutUsDivider/AboutUsDivider";

const AboutUsSection1 = () => {
  const { t } = useTranslation();

  return (
    <section>
      <AboutUsDivider heading={t("aboutUsSection1.heading")} />
      <section className="content-aboutus">
        <blockquote className="quote-container">
          <p>"{t("aboutUsSection1.quote")}"</p>
          <footer className="author-aboutus">
            {t("aboutUsSection1.author")}
            <br />
            <cite className="author-info">
              {t("aboutUsSection1.authorInfo")}
            </cite>
          </footer>
        </blockquote>
        <figure className="image-container-aboutus">
          <img
            src={Agha}
            alt={t("aboutUsSection1.author")}
            className="person-image"
          />
        </figure>
      </section>
    </section>
  );
};

export default AboutUsSection1;
